// import Navigation from "../navigation";
import React, { useEffect, useRef } from "react";
import styles from "./index.module.scss";
import WebsiteHeader from "fotor-website-header/websiteHeaderNoCss.bundle";
import { autoShowOpenAppConfirm, setCookie } from "@/utils";
import { I18nLangMap, NAV_POSITION, PROJECT_TYPE, SCENE_ID } from "@/constants";
import { useUserStore } from "@/stores";
import { useIsMobile } from "@/hooks";
import { useTranslation } from "react-i18next";
import EventHub from "@/utils/event";
import { GlobalEvent } from "@/constants/event";
import PcHeaderComponent from "../nav-download";
import useEffectStore from "@/stores/effectStore";

interface HeaderProps {
  mobileContent?: React.ReactNode;
  className?: string;
  onLogin?: () => void;
}
export default function Header(props: HeaderProps) {
  const { mobileContent, className } = props;
  const headerCompRef = useRef<any>();
  const { i18n } = useTranslation();
  const logoutCallback = useEffectStore((state) => state.logoutCallback);
  const resetUserStore = useUserStore((state) => state.reset);
  const setUserInfo = useUserStore((state) => state.setUserInfo);
  const fetchVipStatus = useUserStore((state) => state.fetchVipStatus);
  const receiveCredits = useUserStore((state) => state.receiveCredits);
  const fetchCredits = useUserStore((state) => state.fetchCredits);
  const setCredits = useUserStore((state) => state.setCredits);
  const fetchUserInfo = useUserStore((state) => state.fetchUserInfo);
  const isMobile = useIsMobile();

  // 点击右上角的头像同步更新头里的积分
  useEffect(() => {
    const el = document.querySelector(".login-header");
    if (el) {
      el.addEventListener("click", () => {
        EventHub.getInstance().emit(GlobalEvent.REFRESH_CREDITS);
      });
    }
    return () => {
      if (el) {
        el.removeEventListener("click", () => {
          EventHub.getInstance().emit(GlobalEvent.REFRESH_CREDITS);
        });
      }
    };
  }, []);

  useEffect(() => {
    const remover = EventHub.getInstance().on(
      GlobalEvent.REFRESH_CREDITS,
      () => {
        fetchCredits().then(() => {
          const credits = useUserStore.getState().credits;
          if (typeof credits === "number" && credits >= 0) {
            setCredits(credits);
            headerCompRef.current?.updateCredits(credits);
          }
        });
      }
    );
    return () => {
      remover();
    };
  }, []);
  const headerCallback = (data: any) => {
    let { type } = data;

    if (type === "logout") {
      logoutCallback();
      resetUserStore();
      useUserStore.getState().refreshFreeCount();
    } else if (type === "rendered") {
    } else if (type === "login") {
      props.onLogin?.();
      if ([0, 1, 2, 3, 5, 6].includes(data.res.code)) {
        setUserInfo(data.res.userInfo.data);
        fetchVipStatus();
        receiveCredits().then(() => {
          EventHub.getInstance().emit(GlobalEvent.REFRESH_CREDITS);
        });
      }
      if (data.res.code === 4) {
        // 取消了登录，让他去app//自动拉起[open app]弹窗
        autoShowOpenAppConfirm();
      }
    } else if (type === "language") {
      const localeKey = data.value || "en_US";
      const i18nKey = Object.keys(I18nLangMap).find(
        (key) => I18nLangMap[key] === localeKey
      );
      if (!["id"].includes(i18nKey!)) {
        setCookie("locale", localeKey);
      }
      i18n.changeLanguage(i18nKey);
    }
  };

  const handleChangeCredits = (credits: number) => {
    setCredits(credits);
    headerCompRef.current?.updateCredits(credits);
  };

  return (
    <WebsiteHeader
      ref={headerCompRef}
      style={{
        background: "#FFFFFF",
        boxShadow: "0px 1px 0px 0px rgba(0, 0, 0, 0.1)",
        position: "static",
      }}
      displayLanguageMenu={[
        "en",
        "es",
        "pt",
        "ru",
        "fr",
        "de",
        "cn",
        "tw",
        "jp",
        "id",
        "it",
        "th",
        "vi",
        "tr",
        "pl",
        "nl",
        "ko",
      ]}
      showOpenInApp={false}
      projectType={PROJECT_TYPE}
      noNavMenu={false}
      lang={I18nLangMap[i18n.language]}
      callback={headerCallback}
      noLanguage={true}
      ShowUpgradeButton={false}
      theme="white"
      env={process.env.REACT_APP_ENVIRONMENT}
      loginSensorsData={[
        { position: NAV_POSITION },
        true,
        { scenesId: SCENE_ID },
      ]}
      signUpSensorData={[
        { position: NAV_POSITION },
        true,
        { scenesId: SCENE_ID },
      ]}
      showCredits={{
        sensorsData: {

          project_type: PROJECT_TYPE,
          position: "figure_upgrade",
        },
      }}
      pageType="tool"
      onChangeCredits={handleChangeCredits}
      className={className}
    >
      {/* {!isMobile && <Navigation></Navigation>} */}
      {!isMobile && <PcHeaderComponent />}
      {isMobile && mobileContent}
    </WebsiteHeader>
  );
}
